import { Button } from "primereact/button"
import { useState } from "react"
import { convertAdditionalQuestionsOptions } from "../utils/utils"
import { OrderList } from "primereact/orderlist"
import { Panel } from "primereact/panel"
import styles from "../../../styles/Participant-GPRA.module.css"
const Group = ({
  group,
  setAdditionalQuestionToDelete,
  setAdditionalEditing,
  disabled,
  setShowAddAdditional,
  setShowAddGroup,
  setGroupToDelete,
  setGroupEditing,
  questions,
  updateQuestions,
  blocked,
  setShowConfirm,
}) => {
  useState(null)
  const itemTemplate = (item) => {
    return (
      <>
        {item.header && (
          <div
            className={"additional-order-header"}
            style={{
              display: "inline-grid",
              gridTemplateColumns:
                "20px 300px 150px 50px 200px 50px 50px 150px",
              columnGap: "60px",
              fontWeight: "600",
              marginBottom: "10px",
              backgroundColor: "#efefef",
              height: "50px",
              width: "100%",
              paddingLeft: "20px",
              paddingTop: "10px",
            }}
          >
            <div>{item.number}</div>
            <div>{item.title}</div>
            <div>{item.description}</div>
            <div>{item.type}</div>
            <div>{item.options}</div>
            <div>{item.enabled}</div>
            <div>{item.required}</div>
          </div>
        )}
        {!item.header && (
          <div
            style={{
              display: "inline-grid",
              gridTemplateColumns:
                "20px 300px 150px 50px 200px 50px 50px 150px",
              columnGap: "60px",
              marginLeft: "23px",
            }}
          >
            <div>{item.groupOrder ? item.groupOrder : item.number}</div>
            <div>{item.title}</div>
            <div>{item.description}</div>
            <div>{item.type}</div>
            <div>{item.options}</div>
            <div>{item.enabled ? "Yes" : "No"}</div>
            <div>{item.required ? "Yes" : "No"}</div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                flex: "1",
                alignSelf: "baseline",
              }}
            >
              <Button
                disabled={disabled || blocked}
                onClick={() => {
                  if (!blocked) {
                    setAdditionalEditing({
                      id: item.id,
                      description: item.description,
                      number: item.number,
                      type: item.type,
                      title: item.title,
                      oldTitle: item.title,
                      options: convertAdditionalQuestionsOptions(item.options),
                      enabled: item.enabled,
                      required: item.required,
                      groupOrder: item.groupOrder,
                      groupId: item.questionGroup?.title,
                      editing: true,
                      grouped: true,
                      oldGroupId: item.questionGroup?.title,
                      conditionalSource: item.conditionalSource,
                      conditionalType: item.conditionalType,
                      conditionalValue: !item.conditionalValue
                        ? ""
                        : item.conditionalValue,
                      conditionalRequired: item.conditionalRequired,
                      conditionalDisplay: item.conditionalDisplay,
                    })
                    setShowAddAdditional(true)
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-pencil"
                style={{ marginRight: "20px" }}
              />
              <Button
                disabled={disabled || blocked}
                onClick={() => {
                  if (!blocked) {
                    setAdditionalQuestionToDelete({ ...item, grouped: true })
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-times"
                style={{ backgroundColor: "red" }}
              />
            </div>
          </div>
        )}
      </>
    )
  }
  const setNumbers = (values) => {
    let index = 0
    const newValues = values
      ?.filter((v) => !v.header)
      .map((value) => {
        const newValue = { ...value, groupOrder: index + 1 }
        index = index + 1
        return newValue
      })
    const updatedAdditionals = questions?.additionalQuestions.map((a) => {
      let newValue = { ...a }
      const updated = newValues?.find(
        (v) =>
          v.title === a.title && v.section === a.section && v.form === a.form
      )
      if (updated) {
        newValue = updated
      }
      return newValue
    })
    const updateGroups = questions?.groups?.map((g) => {
      let newValue = { ...g }
      if (newValue.title === group.title) {
        const additionalUpdated = newValue?.additionalQuestions?.map((a) => {
          const updated = newValues?.find((v) => v.title === a.title)
          let newAdditional = { ...a }
          if (updated) {
            newAdditional = updated
          }
          return newAdditional
        })
        newValue.additionalQuestions = additionalUpdated
      }
      return newValue
    })
    updateQuestions({
      ...questions,
      additionalQuestions: updatedAdditionals,
      groups: updateGroups,
    })
  }
  const template = (options) => {
    const toggleIcon = options.collapsed ? "pi pi-plus" : "pi pi-minus"
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "30px 550px 200px 150px 135px 200px",
          gridTemplateRows: "auto auto",
          columnGap: "50px",
          rowGap: "5px",
          fontWeight: "600",
          paddingLeft: "1rem",
          paddingBottom: "1rem",
          paddingTop: "1rem",
          marginBottom: "5px",
          backgroundColor: "#efefef",
          width: "100%",
        }}
      >
        <span>Number</span>
        <div>Title</div>
        <div>Alignment</div>
        <div>Enabled</div>
        <div>Expanded</div>
        <div
          style={{
            gridColumnStart: "6",
            gridColumnEnd: "7",
            gridRowStart: "1",
            gridRowEnd: "3",
          }}
        >
          <div style={{ display: "flex", marginTop: "0.5rem" }}>
            <div style={{ marginRight: "2rem", marginLeft: "2rem" }}>
              <Button
                disabled={disabled || blocked}
                onClick={() => {
                  if (!blocked) {
                    setGroupEditing({
                      id: group.id,
                      organizationUuid: group.organizationUuid,
                      form: group.form,
                      section: group.section,
                      title: group.title,
                      oldTitle: group.title,
                      enabled: group.enabled,
                      expanded: group.expanded,
                      required: group.required,
                      number: group.number,
                      organizations: group.organizations,
                      editing: true,
                      selectedOrganizations: group.selectedOrganizations,
                      alignment: group.alignment,
                      groupOrder: group.groupOrder,
                      matrixId: group.matrixGroup?.title,
                      additionalQuestions: group.additionalQuestions,
                      matrixGroup: group?.matrixGroup,
                    })
                    setShowAddGroup(true)
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-pencil"
                style={{ marginRight: "30px" }}
              />
              <Button
                disabled={
                  disabled ||
                  (group.additionalQuestions &&
                    group.additionalQuestions?.length !== 0 &&
                    !allQuestionDeleted()) ||
                  blocked
                }
                onClick={() => {
                  if (!blocked) {
                    setGroupToDelete(group)
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-times"
                style={{ backgroundColor: "red" }}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <Button
                className={options.togglerClassName}
                onClick={options.onTogglerClick}
              >
                <span
                  className={toggleIcon}
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "20px",
                  }}
                ></span>
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.lighter}>
          {group.matrixGroup ? group.groupOrder : group.number}
        </div>
        <div className={styles.lighter}>{group.title}</div>
        <div className={styles.lighter}>{`${
          group.alignment === 0 ? "Horizontal" : "Vertical"
        }`}</div>
        <div className={styles.lighter}>{group.enabled ? "Yes" : "No"}</div>
        <div className={styles.lighter}>{group.expanded ? "Yes" : "No"}</div>
      </div>
    )
  }
  const allQuestionDeleted = () => {
    return group?.additionalQuestions?.every((q) => q.deleted)
  }
  const setValues = () => {
    const additionalQuestions = group?.additionalQuestions
      ?.filter((a) => !a.deleted)
      .sort((a, b) => {
        return a.groupOrder - b.groupOrder
      })
    const header = [
      {
        header: true,
        number: "Number",
        title: "Title",
        description: "Description",
        type: "Type",
        options: "Options",
        enabled: "Enabled",
        required: "Required",
      },
    ]
    return [...header, ...additionalQuestions]
  }
  return (
    <Panel className="custom-panel" headerTemplate={template} toggleable>
      {group?.additionalQuestions?.length > 0 && !allQuestionDeleted() ? (
        <OrderList
          value={setValues()}
          itemTemplate={itemTemplate}
          dataKey="title"
          onChange={(e) => {
            if (!blocked) {
              setNumbers(e.value)
            } else {
              setShowConfirm(true)
            }
          }}
        ></OrderList>
      ) : (
        <div>No questions available</div>
      )}
    </Panel>
  )
}
export default Group
